module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "videopopup popup",
    class: {
      show: _vm.open
    }
  }, [_c('div', {
    staticClass: "popupblock"
  }, [_c('youtube', {
    attrs: {
      "player-width": "100%",
      "player-height": "100%",
      "video-id": _vm.videoId,
      "player-vars": _vm.playVars
    },
    on: {
      "playing": _vm.playing,
      "ready": _vm.ready
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "close",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('svg', {
    staticClass: "closebtn"
  }, [_c('title', [_vm._v("close")]), _c('g', {
    attrs: {
      "data-name": "close"
    }
  }, [_c('path', {
    attrs: {
      "d": "M31.67,2.59c1.26-1.43-.84-3.55-2.1-2.1-4.2,4.78-8.72,9.26-13.3,13.69C11.84,9.47,7.4,4.78,2.58.48,1.16-.79-1,1.31.48,2.59c4.81,4.28,9.23,9,13.64,13.65C9.86,20.33,5.58,24.4,1.48,28.63c-1.33,1.38.77,3.48,2.1,2.1,4.08-4.21,8.34-8.26,12.58-12.34,4,4.24,8,8.45,12.4,12.34,1.43,1.27,3.54-.83,2.1-2.1-4.34-3.87-8.37-8.06-12.36-12.3C22.91,11.89,27.45,7.38,31.67,2.59Z"
    }
  })])]), _vm._v(" "), _c('svg', {
    staticClass: "arrowbg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 90.86 93.28"
    }
  }, [_c('title', [_vm._v("btn")]), _c('path', {
    attrs: {
      "d": "M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "fixblack",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75240532"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Popup.vue
// module id = 258
// module chunks = 0